import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { Flex, Stack } from '@mantine/core';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';

import type { IColumn } from '@feathr/components';
import { Icon, ProgressBar, Text, Tooltip } from '@feathr/components';

import type { ITransformedMonthlyData } from './EmailLimits.types';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

export function monthlyBreakdownColumns(
  totalIncrementalCosts: number,
): Array<IColumn<ITransformedMonthlyData>> {
  return [
    {
      accessor: 'humanMonth',
      Header: 'Description',
      Footer: () => <Text.DefaultMedium>Page totals</Text.DefaultMedium>,
      sortable: false,
    },
    {
      accessor: 'humanSummary',
      Header: 'Emails Sent',
      Cell: ({ value }) => <span>{value}</span>,
      Footer: '',
      sortable: false,
    },
    {
      accessor: 'percentage',
      Header: 'Used %',
      Cell: ({ row }): JSX.Element => {
        const isOverage = row.percentage > 100;
        const roundedPercentage = Math.round(row.percentage);

        return (
          <Stack gap={2}>
            <ProgressBar max={100} theme={isOverage ? 'red' : 'cyan'} value={row.percentage} />
            <Flex align={'center'} justify={'space-between'}>
              <Text.DefaultMedium>{roundedPercentage}%</Text.DefaultMedium>
              {isOverage && (
                <Tooltip
                  title={
                    'Your organization has reached its monthly email allocation. You will now be billed for any email sends exceeding this limit.'
                  }
                >
                  <Icon icon={faInfoCircle} />
                </Tooltip>
              )}
            </Flex>
          </Stack>
        );
      },
      Footer: '',
      sortable: false,
    },
    {
      accessor: 'humanIncrementalCosts',
      Header: 'Incremental Costs',
      className: tableStyles.cellRight,
      footerClassName: tableStyles.cellRight,
      Cell: ({ value }) => <Text.DefaultMedium>{value}</Text.DefaultMedium>,
      Footer: () => (
        <Text.DefaultMedium>
          {totalIncrementalCosts > 0 ? `$${numeral(totalIncrementalCosts).format('0,0.00')}` : '-'}
        </Text.DefaultMedium>
      ),
      sortable: false,
    },
  ];
}
